<template>
  <screen
    v-show="show"
    :screen-name="$t('stamp.tutorial.title')"
    :screen-info="info"
    @skip="$emit('skip')"
  >
    <doll :left="left" :right="right" :left-range="[150, 200]" :right-range="[150, 200]" />
  </screen>
</template>

<script>
import audioPlayer from '@/mixins/audio-player';
import { wait } from '@/modules/utils';
import i18n from '@/i18n';
import Screen from '../Screen.vue';
import Doll from '../Doll.vue';

export default {
  name: 'HandRaiseReady',
  mixins: [audioPlayer],
  components: {
    Screen,
    Doll,
  },
  props: {
    show: Boolean,
  },
  data: () => ({
    left: 0,
    right: 0,
    info: i18n.t('stamp.tutorial.raise_arm'),
  }),
  watch: {
    show(nv) {
      if (!nv) return;

      this.playAudio('Voice3')
        .then(() => wait(0.5))
        .then(() => {
          this.left = 170;
          this.right = 170;
          this.info = i18n.t('stamp.tutorial.raise_arm_2');
          return this.playAudio('Voice4');
        })
        .then(() => wait(0.5))
        .then(() => this.$emit('next'));
    },
  },
};
</script>
